<template>
  <div id="app">
    <TheHeader v-if="showtitle"></TheHeader>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <TheFooter v-if="showtitle"></TheFooter>
  </div>
</template>

<script>
import TheFooter from '@/components/footer';
import TheHeader from '@/components/header';
export default {
  name: 'app',
  components: {
    TheFooter,
    TheHeader,
  },
  computed: {
    showtitle() {
      return !this.$route.meta.hideTitle;
    },
  },
};
</script>
<style lang="scss">
#app {
  min-width: 1200px;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
}
</style>
